
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext'

type Props = {
    question: ObjectStringKeyAnyValue
    classString: string
    classString2?: string
    checkPeriodId: string
    questionAnswer?: any
}


function DisplayAverage({
    question,
    checkPeriodId,
    classString,
    classString2,
    questionAnswer
}: Props) {

    const [answersForThisQuestion, setAnswersForThisQuestion] = useState<null | Array<ObjectStringKeyAnyValue>>(null)
    const {tableData} = useContext(GlobalContext)

    const isQuestionNumber = question && question.QuestionFormat === 'Number'
    const displayRunningAverage = question && question.displayRunningAverage === true
    const MeasurementUnit = question && question.MeasurementUnit ? question.MeasurementUnit : ''



    useEffect(() => {
        if (question && checkPeriodId && tableData && tableData['ChecklistAnswers']) {
            const questionId = question.Id
            const newAnswersForThisQuestion: Array<ObjectStringKeyAnyValue> = []
            Object.values(tableData['ChecklistAnswers']).forEach((answerObj: any) => {
                //console.log(`answer question id: ${answerObj.QuestionId} vs ${questionId} for check period id: ${answerObj.ChecklistPeriodId} vs ${checkPeriodId}`)
                if (
                    answerObj.QuestionId === questionId && 
                    answerObj.ChecklistPeriodId === checkPeriodId && 
                    answerObj.Answer &&
                    !answerObj.AnswerSkipped 
                ) {
                    newAnswersForThisQuestion.push(answerObj)
                }
            })
            setAnswersForThisQuestion(newAnswersForThisQuestion)
        } 
    }, [question, checkPeriodId, tableData])

    const findAverageAnswer = (answersForThisQuestion: Array<ObjectStringKeyAnyValue>) => {
        let sum = 0
        let count = 0

        answersForThisQuestion.forEach((answerObj) => {
            const answerValue = parseFloat(answerObj.Answer)
            if (!isNaN(answerValue)) {
                sum += answerValue
                count += 1
            }
        })

        return count > 0 ? (sum / count).toFixed(1) : null
    }




    if (
        !isQuestionNumber || 
        !answersForThisQuestion || 
        !displayRunningAverage ||
        answersForThisQuestion.length < 1
    ) {
        return null
    }



    return <>
    <span className={classString}> 
        Average of {answersForThisQuestion.length} saved answer{answersForThisQuestion.length !== 1 ? 's' : ''}: {findAverageAnswer(answersForThisQuestion)} {MeasurementUnit}.</span>


        {questionAnswer  && 
            <span className={classString2 || classString}> New average will be: {findAverageAnswer([...answersForThisQuestion, {"Answer": questionAnswer}])} {MeasurementUnit}.</span>}
    
    </>

}

export default DisplayAverage